import {
    UPLOAD_ATTENDANCE_REQUEST,
    UPLOAD_ATTENDANCE_SUCCESS,
    UPLOAD_ATTENDANCE_FAILURE
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const uploadAttendanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_ATTENDANCE_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case UPLOAD_ATTENDANCE_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case UPLOAD_ATTENDANCE_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default uploadAttendanceReducer;